export default __webpack_public_path__ + "static/5-1e04956897ebc98715ac350fa84d6d92.jpeg";